import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { MonthBookingBar } from '@/utils/myBookingsWidget';

interface MyBookingsMonthChartProps {
  title: string;
  rangeLabel: string;
  completedLabel: string;
  upcomingLabel: string;
  bars: MonthBookingBar[];
}

const COMPLETED = '#0f766e';
const UPCOMING = '#2dd4bf';

/** Stapeldiagram: avslutade och kommande bokningar, sex månader. */
const MyBookingsMonthChart: React.FC<MyBookingsMonthChartProps> = ({
  title,
  rangeLabel,
  completedLabel,
  upcomingLabel,
  bars,
}) => (
  <div className="flex min-h-0 min-w-0 flex-1 flex-col rounded-xl border border-borderDefault bg-bgBase/40 p-3">
    <div className="mb-2 flex shrink-0 items-center justify-between gap-2">
      <h3 className="text-sm font-semibold text-textDefault">{title}</h3>
      <span className="text-xs text-textTertiary">{rangeLabel}</span>
    </div>
    <div className="min-h-[7rem] flex-1">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={bars} barCategoryGap="30%">
          <CartesianGrid vertical={false} stroke="var(--borderDefault)" strokeOpacity={0.7} />
          <XAxis dataKey="label" axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: 'var(--textTertiary)' }} />
          <YAxis
            allowDecimals={false}
            width={28}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11, fill: 'var(--textTertiary)' }}
          />
          <Tooltip
            cursor={{ fill: 'rgba(45, 212, 191, 0.08)' }}
            contentStyle={{
              background: 'var(--bgElevated)',
              border: '1px solid var(--borderDefault)',
              borderRadius: 8,
              fontSize: 12,
              color: 'var(--textDefault)',
            }}
          />
          <Bar dataKey="completed" name={completedLabel} stackId="month" fill={COMPLETED} maxBarSize={28} />
          <Bar dataKey="upcoming" name={upcomingLabel} stackId="month" fill={UPCOMING} radius={[4, 4, 0, 0]} maxBarSize={28} />
        </BarChart>
      </ResponsiveContainer>
    </div>
    <div className="mt-1 flex shrink-0 items-center gap-4 text-xs text-textSecondary">
      <span className="inline-flex items-center gap-1.5">
        <span className="w-2.5 h-2.5 rounded-sm" style={{ background: COMPLETED }} />
        {completedLabel}
      </span>
      <span className="inline-flex items-center gap-1.5">
        <span className="w-2.5 h-2.5 rounded-sm" style={{ background: UPCOMING }} />
        {upcomingLabel}
      </span>
    </div>
  </div>
);

export default MyBookingsMonthChart;
